/* ────────────────────────────────────────────────────────────
   Metadata de los posts del blog — compartida entre BlogPage
   (listado) y BlogPostPage (detalle) para no duplicar slugs/tags.
   El texto real (título, excerpt, fecha…) vive en los locales
   i18n bajo la clave `blog_page.<key>_*`, esto solo mapea slug → key.
   ──────────────────────────────────────────────────────────── */

export type TagVariant = 'green' | 'yellow' | 'red' | 'blue';

// Slug de categoría ESTABLE (no depende del idioma) — usado por el filtro de
// categorías del listado. La etiqueta visible sale de `blog_page.<key>_tag`
// (ya traducida en es/en/pt), esto solo agrupa qué posts caen bajo cada chip.
export type CategorySlug = 'agenda' | 'whatsapp' | 'crm' | 'metricas' | 'ia';

export interface BlogPostMeta {
  key: string;
  slug: string;
  tagVariant: TagVariant;
  category: CategorySlug;
  image: string;
  /** Posición de encuadre del cover (background-position) — ver nota en BlogPage sobre por qué varía por foto. */
  imagePosition?: string;
}

export const FEATURED_POST: BlogPostMeta = {
  key: 'featured',
  slug: 'reducir-inasistencias-clinica-dental',
  tagVariant: 'blue',
  category: 'agenda',
  image: '/blog_noshows_1784869108391.png',
  imagePosition: 'center 45%',
};

export const BLOG_POSTS: BlogPostMeta[] = [
  { key: 'post_1', slug: 'senales-perdiendo-pacientes-whatsapp', tagVariant: 'green', category: 'whatsapp', image: '/blog_whatsapp_1784869116014.png', imagePosition: 'center 55%' },
  { key: 'post_2', slug: 'que-es-un-crm-clinica-dental', tagVariant: 'yellow', category: 'crm', image: '/blog_crm_concept_1784869124913.png', imagePosition: 'center' },
  { key: 'post_3', slug: 'agentes-ia-clinicas-dentales-limites', tagVariant: 'red', category: 'ia', image: '/usecase_clinic_1784868844904.png', imagePosition: 'center 35%' },
  { key: 'post_4', slug: 'metricas-clinica-dental-cada-mes', tagVariant: 'blue', category: 'metricas', image: '/usecase_patient_1784868861045.png', imagePosition: 'center 30%' },
  { key: 'post_5', slug: 'doble-booking-como-evitarlo', tagVariant: 'green', category: 'agenda', image: '/usecase_phone_1784868852788.png', imagePosition: 'center 40%' },
];

export const ALL_POSTS: BlogPostMeta[] = [FEATURED_POST, ...BLOG_POSTS];

export const findPostBySlug = (slug: string | undefined): BlogPostMeta | undefined =>
  ALL_POSTS.find((p) => p.slug === slug);
